import { useEffect } from "react";
import { flushSync } from "react-dom";
import { useNavigate } from "react-router";
import { useOidc } from "@axa-fr/react-oidc";

export function OidcRouteSyncWrapper({ children }: { children: React.ReactNode }) {
    const { isAuthenticated } = useOidc();
    const navigate = useNavigate();

    useEffect(() => {
        // Check if the browser is physically on the callback path and authentication is complete
        if (window.location.pathname === "/authentication/callback" && isAuthenticated) {

            // Bypass React Router v7's deferred startTransition loop completely
            flushSync(() => {
                navigate("/Login", { replace: true });
            });
        }
    }, [isAuthenticated, navigate]);

    return <>{children}</>;
}
